export default {
    slug: 'messages/sms/templates',
    title: 'SMS Templates',
    visible: [
        'id',
        'name',
        'from_number',
    ],
    listview: 'SmsTemplateListView',
    locales: ['common'],
    columns: [
        {
            key: 'name',
            main: true,
            filter: function (value) {
                return {
                    field: 'name',
                    operator: 'LIKE',
                    value: '%' + value + '%'
                };
            }
        }
    ],
    actions: {}
}



// WEBPACK FOOTER //
// ./src/app/store/messages/sms-templates/state.js